import mixpanel from 'mixpanel-browser';

const IS_PRODUCTION = process.env.NODE_ENV === 'production';

mixpanel.init(process.env.REACT_APP_MIXPANEL_TOKEN);

let actions = {
  identify: id => {
    if (IS_PRODUCTION) mixpanel.identify(id);
  },
  alias: id => {
    if (IS_PRODUCTION) mixpanel.alias(id);
  },
  track: (name, props, cb) => {
    if (IS_PRODUCTION) mixpanel.track(name, props, cb);
  },
  people: {
    set: props => {
      if (IS_PRODUCTION) mixpanel.people.set(props);
    },
  },
};

export const Mixpanel = actions;



// WEBPACK FOOTER //
// ./src/Mixpanel.js